import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartCtx = createContext(null);
const KEY = "jn_cart_v6";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const api = useMemo(() => {
    const add = (p, qty = 1, silent = false, variant = null) => {
      const v = variant || p.variants?.[0] || { id: p.id, size: p.size, price: p.price };
      setItems((prev) => {
        const ex = prev.find((i) => i.id === v.id);
        if (ex) return prev.map((i) => (i.id === v.id ? { ...i, qty: Math.min(50, i.qty + qty) } : i));
        return [...prev, { id: v.id, name: p.name, subtitle: p.subtitle, price: v.price, image: p.image, size: v.size, qty }];
      });
      if (!silent) toast.success(`${p.name} ${v.size} añadido al carrito`);
    };
    const setQty = (id, qty) =>
      setItems((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty: Math.min(50, qty) } : i))));
    const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);
    return { add, setQty, remove, clear };
  }, []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartCtx.Provider value={{ items, count, subtotal, open, setOpen, ...api }}>{children}</CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
